import React from "react";
import { FaUserCheck, FaLock, FaFilter, FaTable, FaUserEdit } from "react-icons/fa";
import pic1 from "../../assets/images/successStories/story 1.png";
import pic2 from "../../assets/images/successStories/story 2.png";
import pic3 from "../../assets/images/successStories/story 3.png";
import TeamCard from "./TeamCard";
import FeatureCard from "./FeatureCard";

const teamMembers = [
  { name: "Jyotsna Pai", position: "Co-founder" },
  { name: "Venkatesh Pai", position: "Co-founder" },
  { name: "Pranav Pai", position: "Head of Marketing" },
  { name: "Vybhav Pai", position: "Executive Director" },
  { name: "Aakash Singh", position: "Head of Technical Team" },
  { name: "Anmol", position: "Developer" },
  { name: "Vinaya Shanbhag", position: "Customer Support Specialist" }
];

const features = [
  { icon: <FaUserCheck />, title: "Validated Members: Only validated members are onboarded to our platform." },
  { icon: <FaLock />, title: "Data Privacy: Your data is stored securely and accessed only by platform members." },
  { icon: <FaFilter />, title: "Filter Profiles: Find profiles that match your interests using our advanced filters." },
  { icon: <FaTable />, title: "Structured Data: Profile information is well-organized for easy access." },
  { icon: <FaUserEdit />, title: "Profile Management: Update your profile effortlessly with a single click." }
];

function AboutPage() {
  return (
    <div className="max-w-7xl mx-auto p-5">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="flex flex-col justify-start">
          <h1 className="text-4xl font-bold mb-4 text-left">About Us</h1>
          <p className="text-lg text-gray-700 mb-6">
            We assist you in finding your life partner by providing access to
            information on candidates from the GSB community worldwide. Your
            preferences combined with our recommendations will enhance your
            chances of finding the perfect match.{" "}
            <strong className="text-blue-500">#AmchigelePartner</strong>
          </p>
          <p className="text-lg text-gray-700">
            What began as a hobby for Jyotsna Pai—to connect people and help
            them find the right partners—quickly evolved into a community-wide
            initiative. By engaging in conversations and tapping into her vast
            network, Jyotsna understood the desires of individuals, offering
            tailored recommendations for potential matches. As the initiative
            gained traction, she, with the support of her husband, Mr. Venkatesh
            Pai, began managing interactions through WhatsApp groups.
            Recognizing the need for more structured access to information, they
            launched the GSB Soirika website.
          </p>
        </div>
        <a className="flex gap-2" href="/successStories">
          <div className="w-[50%]">
            <img
              src={pic1}
              alt="success-stories"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          <div className="w-[50%] flex flex-col gap-2">
            <img
              src={pic2}
              alt="success-stories"
              className="w-full h-[50%] object-cover rounded-lg"
            />
            <img
              src={pic3}
              alt="success-stories"
              className="w-full h-[50%] object-cover rounded-lg"
            />
          </div>
        </a>
      </div>
      <div className="mt-10">
        <h2 className="text-3xl font-bold mb-6">Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} icon={feature.icon} title={feature.title} />
          ))}
        </div>
      </div>
      <div className="mt-10">
        <h2 className="text-3xl font-bold mb-6">Our Team</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <TeamCard key={index} name={member.name} position={member.position} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
